import React, { useEffect, useMemo, useState } from "react";
import { Global } from "../helpers/Global";

export const FinalizarInterManualAdmin = () => {
  const [ticajes, setTicajes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [centros, setCentros] = useState([]);
  const [ordenes, setOrdenes] = useState([]);

  const [mensaje, setMensaje] = useState("");
  const [formData, setFormData] = useState({});
  const [working, setWorking] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetchTodo();
  }, []);

  const fetchTodo = async () => {
    setCargando(true);
    try {
      const [resT, resU, resC, resCentros, resOts] = await Promise.all([
        fetch(Global.url + "ticajes/proceso", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }),
        fetch(Global.url + "usuarios", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }),
        fetch(Global.url + "clientes", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }),
        fetch(Global.url + "centros/todos", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }),
        fetch(Global.url + "ordenes", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }),
      ]);

      if (resT.ok && resU.ok && resC.ok && resCentros.ok && resOts.ok) {
        const [dataT, dataU, dataC, dataCent, dataOts] = await Promise.all([
          resT.json(), resU.json(), resC.json(), resCentros.json(), resOts.json()
        ]);
        setTicajes(Array.isArray(dataT) ? dataT : []);
        setUsuarios(Array.isArray(dataU) ? dataU : []);
        setClientes(Array.isArray(dataC) ? dataC : []);
        setCentros(Array.isArray(dataCent) ? dataCent : []);
        setOrdenes(Array.isArray(dataOts) ? dataOts : []);
      } else {
        setMensaje("No se pudieron obtener los datos.");
        limpiarMensaje();
      }
    } catch (e) {
      console.error("Error cargando datos:", e);
      setMensaje("Error de conexión con el servidor.");
      limpiarMensaje();
    } finally {
      setCargando(false);
    }
  };

  const limpiarMensaje = () => setTimeout(() => setMensaje(""), 4000);

  const handleChange = (ticajeId, campo, valor) => {
    setFormData(prev => ({ ...prev, [ticajeId]: { ...prev[ticajeId], [campo]: valor } }));
  };

  // "YYYY-MM-DDTHH:mm" (local) -> ISO string (UTC)
  const toIsoFromLocalDatetime = (value) => {
    if (!value) return value;
    const [date, time] = value.split("T");
    const [y, m, d] = date.split("-").map(Number);
    const [hh, mm] = time.split(":").map(Number);
    const dt = new Date(y, m - 1, d, hh, mm, 0);
    return dt.toISOString();
  };

  const mark = (id, v) => setWorking(w => ({ ...w, [id]: v }));

  const finalizarTicaje = async (ticajeId) => {
    const datos = formData[ticajeId];
    if (!datos?.fecha_fin || !datos?.comentario) {
      setMensaje("Debes rellenar la fecha de fin y el motivo del cierre.");
      limpiarMensaje();
      return;
    }
    if (working[ticajeId]) return;

    const finISO = toIsoFromLocalDatetime(datos.fecha_fin);

    // Debug rápido en consola
    console.log("[Finalizar] id:", ticajeId, "fin local:", datos.fecha_fin, "fin ISO:", finISO);

    mark(ticajeId, true);
    try {
      const res = await fetch(Global.url + "ticajes/finalizar-manualmente", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          id: ticajeId,
          fin: finISO, // <-- el backend hace new Date(fin)
          observaciones_admin: datos.comentario,
          // motivo_fin: datos.motivo_fin || null, // si decides usarlo
        }),
      });

      let result = null;
      try {
        result = await res.json();
      } catch {
        // por si el backend devuelve 200 sin JSON
      }

      if (res.ok) {
        setMensaje("Intervención finalizada correctamente.");
        limpiarMensaje();
        setFormData(prev => ({ ...prev, [ticajeId]: {} }));
        await fetchTodo();
      } else {
        console.warn("[Finalizar] respuesta no OK:", res.status, result);
        setMensaje((result && result.message) || `Error al finalizar (HTTP ${res.status})`);
        limpiarMensaje();
      }
    } catch (error) {
      console.error("❌ Error al finalizar:", error);
      setMensaje("Error de conexión.");
      limpiarMensaje();
    } finally {
      mark(ticajeId, false);
    }
  };

  // maps para labels
  const mapUsuario = useMemo(() => Object.fromEntries(usuarios.map(u => [u.id, [u.nombre, u.apellidos].filter(Boolean).join(" ") || u.nombre])), [usuarios]);
  const mapCliente = useMemo(() => Object.fromEntries(clientes.map(c => [c.id, c.nombre])), [clientes]);
  const mapCentro  = useMemo(() => Object.fromEntries(centros.map(c => [c.id, c.nombre])), [centros]);
  const mapOrden   = useMemo(() => Object.fromEntries(ordenes.map(o => [o.id, o.titulo || `Orden ${o.id}`])), [ordenes]);

  return (
    <div className="consulta-ticajes">
      <h2 className="centrar-titulo">Finalizar Intervenciones en Proceso</h2>
      {mensaje && <div className="alerta">{mensaje}</div>}

      {cargando && <p>Cargando intervenciones...</p>}

      {(!ticajes || ticajes.length === 0) && !cargando ? (
        <p>No hay intervenciones activas actualmente.</p>
      ) : (
        <div className="table-listado-padre">
          <table className="table-listado">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Cliente</th>
                <th>Centro</th>
                <th>Orden</th>
                <th>Inicio</th>
                <th>Comentario</th>
                <th>Fecha Fin</th>
                <th>Motivo</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {ticajes.map((t) => {
                const fila = formData[t.id] || {};
                const busy = !!working[t.id];

                return (
                  <tr key={t.id}>
                    <td>{mapUsuario[t.usuario_id] || t.usuario || t.usuario_id}</td>
                    <td>{mapCliente[t.cliente_id] || t.cliente || t.cliente_id}</td>
                    <td>{mapCentro[t.centro_id] || t.centro || t.centro_id}</td>
                    <td>{mapOrden[t.orden_id] || t.orden || t.orden_id || "-"}</td>
                    <td>{t.inicio ? new Date(t.inicio).toLocaleString() : "-"}</td>
                    <td>{t.comentarios || "Sin comentarios"}</td>
                    <td>
                      <input
                        type="datetime-local"
                        value={fila.fecha_fin || ""}
                        onChange={(e) => handleChange(t.id, "fecha_fin", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        placeholder="Motivo del cierre"
                        value={fila.comentario || ""}
                        onChange={(e) => handleChange(t.id, "comentario", e.target.value)}
                      />
                    </td>
                    <td className="acciones-td">
                      <button
                        type="button"         // <-- importante
                        className="btn-login"
                        onClick={() => finalizarTicaje(t.id)}
                        disabled={!fila.fecha_fin || !fila.comentario || busy}
                        aria-busy={busy}
                      >
                        {busy ? "Procesando..." : "Finalizar"}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
